import { getLockDateWarningText } from 'modules/common/selectors/requestSelectors.QBooks';
import { FC, memo } from 'react';
import bemFactory from 'react-bem-factory';

import FieldEntry from '../../../components/FieldEntry';
import FieldsSection from '../../../components/FieldsSection';
import { messages } from './QBooksBillFields.messages';
import { MailingAddress, Root } from './QBooksBillFields.styles';
import { QBooksBillFieldsProps } from './QBooksBillFields.types';

const qa = bemFactory.qa('reql-qbooks-request-card');

const QBooksBillFields: FC<QBooksBillFieldsProps> = memo((props) => {
    const { request } = props;
    const { details } = request;

    const lockDateWarningText = getLockDateWarningText(request);

    return (
        <Root>
            {details.mailingAddress && (
                <MailingAddress
                    qa={qa('mailingAddress-field')}
                    title={messages.mailingAddressFieldTitle}
                    value={details.mailingAddress}
                />
            )}

            {details.term && (
                <FieldsSection.Field qa={qa('date-field')} title={messages.billTermsFieldTitle} value={details.term} />
            )}

            <FieldsSection.Field
                qa={qa('date-field')}
                title={messages.billDateFieldTitle}
                valueType={FieldsSection.Field.ValueType.Date}
                value={details.date}
                warningText={lockDateWarningText}
            />

            <FieldsSection.Field
                qa={qa('due-date-field')}
                title={messages.billDueDateFieldTitle}
                valueType={FieldsSection.Field.ValueType.Date}
                value={details.dueDate}
            />

            {details.number && (
                <FieldsSection.Field
                    qa={qa('number-field')}
                    title={messages.billNumberFieldTitle}
                    value={details.number}
                />
            )}

            {details.departmentTerminology && details.department && (
                <FieldEntry
                    qa={qa('department-field')}
                    title={details.departmentTerminology}
                    value={details.department}
                />
            )}
        </Root>
    );
});

export default QBooksBillFields;
